import React from 'react'
import Select from 'react-select'

export const VISIBILITY_OPTIONS = [
  {value: 6, label: 'All'},
  {value: 3, label: 'Interpreter'},
  {value: 1, label: 'Requester'},
  {value: 4, label: 'PM'},
  {value: 0, label: 'Do not show in appointment'},
]

export const VISIBILITY_LABELS: Record<number, string> = {
  0: 'Do not show in appointment',
  1: 'Requester',
  3: 'Interpreter',
  4: 'PM',
  6: 'All',
}

export const SELECT_ALL_VISIBILITY_VALUES = [6, 3, 1, 4]

type Props = {
  value: number[]
  onChange: (values: number[]) => void
  disabled?: boolean
}

const VisibilityInAppointmentSelect: React.FC<Props> = ({value, onChange, disabled = false}) => {
  const hasDoNotShow = value.includes(0)
  const selectOptions = hasDoNotShow
    ? VISIBILITY_OPTIONS.filter((o) => o.value === 0)
    : VISIBILITY_OPTIONS

  const allSelectableSelected =
    !hasDoNotShow && SELECT_ALL_VISIBILITY_VALUES.every((v) => value.includes(v))

  const handleVisibilityChange = (opts: readonly {value: number; label: string}[] | null) => {
    const values = opts ? opts.map((o) => o.value) : []
    if (values.includes(0)) {
      onChange([0])
      return
    }
    onChange(values)
  }

  return (
    <div className='col-12'>
      <div className='d-flex justify-content-between align-items-center mb-1'>
        <label className='form-label fs-7 mb-0'>Visibility in Appointment</label>
        <div className='form-check form-check-custom form-check-solid form-check-sm mb-2'>
          <input
            className='form-check-input'
            type='checkbox'
            checked={allSelectableSelected}
            disabled={disabled || hasDoNotShow}
            onChange={(e) => {
              if (e.target.checked) {
                onChange(SELECT_ALL_VISIBILITY_VALUES)
              } else {
                onChange([])
              }
            }}
          />
          <label className='form-check-label'>All</label>
        </div>
      </div>
      <Select
        isMulti
        isDisabled={disabled}
        classNamePrefix='react-select'
        options={selectOptions}
        value={selectOptions.filter((o) => value.includes(o.value))}
        onChange={handleVisibilityChange}
        placeholder='Select visibility'
        isOptionDisabled={(option: {value: number; label: string}) =>
          hasDoNotShow ? option.value !== 0 : false
        }
        menuPortalTarget={document.body}
        styles={{menuPortal: (base: Record<string, unknown>) => ({...base, zIndex: 9999})}}
      />
    </div>
  )
}

export default VisibilityInAppointmentSelect
